<template>
  <div class="content">
    <div class="loader" v-if="loading">
      <loader/>
    </div>
    <div class="home-texts" v-if="!loading">
      <pro-slider></pro-slider>
      <div>
        <div class="concept-page">
          <div v-for="(pro, index) in pros" :key="index" :index="index" :item="pro" class="concept-content"
               :class="{'light-grey': index % 2 === 1}">
            <div class="container">
              <div class="page">
                <div :class="{invest: true, noPicture: !pro.picture}" v-if="index % 2 === 1">
                  <img :src="pro.picture" v-if="pro.picture">
                  <div :class="{texteinvest: true}">
                    <h2 class="titlesection" v-if="pro.pro_texts.title">{{pro.pro_texts.title}}</h2>
                    <p :class="{noTitle: !pro.pro_texts.title}">{{pro.pro_texts.content}}</p>
                  </div>
                </div>
                <div :class="{pro: true, noPicture: !pro.picture}" v-else>
                  <div :class="{textepro: true}">
                    <h2 class="titlesection" v-if="pro.pro_texts.title">{{pro.pro_texts.title}}</h2>
                    <p :class="{noTitle: !pro.pro_texts.title}">{{pro.pro_texts.content}}</p>
                  </div>
                  <img :src="pro.picture" v-if="pro.picture">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Loader from '../../components/loader.component';
  import ProSlider from './pro-slider';
  import {mapState} from 'vuex';
  import {setBodyConcept} from '../../helpers/body-class.helper';

  export default {
    name: 'pro',
    components: {ProSlider, Loader},
    async created() {
      if (this.$route.params) {
        await this.$store.dispatch('proPage/fetch', this.$route.params);
      }
    },
    computed: mapState({
      loading: state => state.proPage.loading,
      pros: state => state.proPage.pros,
    }),
    async mounted() {
      setBodyConcept();
      await this.$store.dispatch('menu/setIndexActive', 0);
    },
  };
</script>

<style scoped>
  .noPicture {
    width: 100%;
    margin: 0;
  }

  .loader {
    height: 120px;
  }

  .noTitle {
    text-align: center;
  }

  .first {
    margin-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/pages/invest-pro/pro.vue